const COORDS = {
    N: [0, 0],
    S: [0, 1],
    E: [1, 0],
    W: [0, 0],
    NE: [1, 0],
    NW: [0, 0],
    SE: [1, 1],
    SW: [0, 1],
    CENTER: [0.5, 0.5],
    ALL: [0, 0],
}

const ANGLE_SUM = {
    N: {
        W: 90,
        E: -90,
    },
    S: {
        W: -270,
        E: 270,
    },
}

const ANGLE_MAP = {
    E: 0,
    N: 90,
    W: 180,
    S: 270,
}

export const PLOT_SIDE = 6

const _feetToCoordUnit = feet => feet / 5280

const _pointFromAngleAndDistance = (x0, y0, distance, angleDeg) => {
    const angleRad = angleDeg * Math.PI / 180
    
    const x1 = x0 + distance * Math.cos(angleRad)
    const y1 = y0 + distance * Math.sin(angleRad)
    
    return { x: x1, y: y1 }
}

const _getPobCoord = plot => {
    const { section, pobInfo: { quarters, halves, location } } = plot
    
    const row = Math.floor((section - 1) / PLOT_SIDE)
    
    let top = (Math.ceil(section / PLOT_SIDE) - 1) * -1
    let left = row % 2 ? (section - 1) % PLOT_SIDE : (PLOT_SIDE - 1) - ((section - 1) % PLOT_SIDE)
    
    // console.log(`section: ${section}, row: ${row}, top: ${top}, left: ${left}`)
    
    let level = 2
    let hJump, vJump
    
    quarters?.forEach(q => {
        const [x, y] = COORDS[q] || []
        
        if (x === undefined || y === undefined) {
            console.error('Found unmapped "quarter" info, ignoring it: ', q)
            return
        }
        
        top -= y / level
        left += x / level
        
        level *= 2
    })
    
    const quarterLevel = level
    
    hJump = level
    vJump = level
    
    halves?.forEach(h => {
        const [x, y] = COORDS[h] || []
        
        if (x === undefined || y === undefined) {
            console.error('Found unmapped "half" info, ignoring it: ', h)
            return
        }
        
        top -= y / level
        left += x / level
        
        if (location === 'ALL') {
            if (['N', 'S'].includes(h))
                vJump *= 2
            else
                hJump *= 2
        }
        
        level *= 2
    })
    
    const [x, y] = COORDS[location || 'CENTER']
    
    top -= y / (quarterLevel / 2)
    left += x / (level / 2)
    
    // console.log(`section: ${section}, quarters: ${quarters}, halves: ${halves}, pob_corner: ${pob_corner}`)
    // console.log(`section: ${section}, top: ${top}, left: ${left}`)
    
    // i need to calculate the size of vertical and horizontal sides for plot with pob_corner ALL
    const vSize = 1 / (vJump / 2)
    const hSize = 1 / (hJump / 2)
    
    plot.pobInfo.coords = { top, left, vSize, hSize }
    
    return [top, left]
}

const _getCoordsFromPobOnly = (plot, coords) => {
    
    if (plot.pobInfo.location === 'ALL') {
        // it MUST respect this order because i have no idea
        ['S', 'E', 'N', 'W'].forEach(key => {
            const lastCoord = coords[coords.length - 1]
            
            const angle = ANGLE_MAP[key]
            
            const distance = ['N', 'S'].includes(key)
                ? plot.pobInfo.coords.vSize
                : plot.pobInfo.coords.hSize
            
            const newCoord = _pointFromAngleAndDistance(lastCoord[1], lastCoord[0], distance, angle)
            
            coords.push([newCoord.y, newCoord.x])
        })
        
    }
    
}

const _plotWithLegs = (plot, coords) => {
    
    plot.legs.forEach(leg => {
        const lastCoord = coords[coords.length - 1]
        
        let angle
        
        // scenario where angle is not provided but we have either initial or departure.
        if (!leg.angle && (!leg.departure || !leg.initial)) {
            
            angle = ANGLE_MAP[leg.initial || leg.departure] || 0
            
        } else {
            
            // when we have all information
            const initial = ['N', 'S'].includes(leg.initial)
                ? leg.initial
                : 'N'
            const departure = ['E', 'W'].includes(leg.departure)
                ? leg.departure
                : (['E', 'W'].includes(leg.initial) ? leg.initial : 'E')
            
            angle = Math.abs(ANGLE_SUM[initial][departure] + parseFloat(leg.angle)) || 0
        }
        
        const distance = _feetToCoordUnit(leg.distanceFeet || 0)
        const newCoord = _pointFromAngleAndDistance(lastCoord[1], lastCoord[0], distance, angle)
        
        coords.push([newCoord.y, newCoord.x])
    })
    
}

export const findCoords = plot => {
    
    const coords = [_getPobCoord(plot)]
    
    if (!plot.legs?.length) {
        
        // we know the size of vertical and horizontal sides and we know that it always starts from NW corner
        _getCoordsFromPobOnly(plot, coords)
        
        return coords
    }
    
    _plotWithLegs(plot, coords)
    
    
    return coords
}